import { api_create_setup_intent_path, api_create_subscription_path } from '@routes';

import request from './request';

interface SubscriptionParams {
  code: string;
  stripe_customer_id: string;
}

type SetupIntentParams = Omit<SubscriptionParams, 'code'>;

interface StripeSetupIntentResponse {
  clientSecret: string;
}

interface StripeSubscriptionResponse extends StripeSetupIntentResponse {
  subscriptionId: string;
}

export const createSubscription = async (
  params: SubscriptionParams
): Promise<StripeSubscriptionResponse> => {
  const response = await request('post', api_create_subscription_path(params));
  return response;
};

export const createSetupIntent = async (
  params: SetupIntentParams
): Promise<StripeSetupIntentResponse> => {
  const response = await request('post', api_create_setup_intent_path(params));
  return response;
};
